import { ApolloError, useQuery } from '@apollo/client'

import { GetCountriesAndReportGenerationFlagsQuery, GetCountriesAndReportGenerationFlagsQueryVariables } from '../../../types'
import { GET_COUNTRIES_AND_REPORT_GENERATION_FLAGS } from '../Queries'

export default function (): {
  data: GetCountriesAndReportGenerationFlagsQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} {
  const { data, error, loading } = useQuery<GetCountriesAndReportGenerationFlagsQuery, GetCountriesAndReportGenerationFlagsQueryVariables>(
    GET_COUNTRIES_AND_REPORT_GENERATION_FLAGS,
    {
      fetchPolicy: 'network-only',
    },
  )
  return { data, error, loading }
}
